// DO NOT EDIT -- generated from fs/api/segment/event.proto

import { AbandonedOperator, ApiErrorOperator, BoolOperator, BrowserOperator, CssOperator, CustomEventOperator, CustomFieldBoolOperator, CustomFieldBoolsOperator, CustomFieldDateOperator, CustomFieldDatesOperator, CustomFieldFloatOperator, CustomFieldFloatsOperator, CustomFieldIntOperator, CustomFieldIntsOperator, CustomFieldStringOperator, CustomFieldStringsOperator, DatalossOperator, DatalossOriginOperator, DatalossTypeOperator, DateOperator, DefinedEventOperator, DeviceOperator, DurationOperator, ElementIdOperator, ElementOperator, ErrorClickTypeOperator, FloatOperator, NativePlatformOperator, NoneOperator, NumericIdOperator, NumericOperator, OSOperator, PageRefOperator, PinchGestureOperator, PlatformOperator, SeenVisibilityOperator, SessionTypeOperator, SignedUpOperator, SpecEventOperator, StringOperator, StringRangeOperator, SuspiciousActivityCategoryOperator, SuspiciousActivityOperator, SuspiciousActivityTypeOperator, TextOperator, UrlOperator } from './operators.proto';

export interface Event {
  primary: EventFilter | null;
  deps: DependentEventFilter[];
}

export interface EventFilter {
  click?: ElementOperator | null;
  change?: ElementOperator | null;
  rageClick?: ElementOperator | null;
  errorClick?: ElementOperator | null;
  deadClick?: ElementOperator | null;
  suspiciousActivity?: ElementOperator | null;
  visitedUrl?: UrlOperator | null;
  ajaxErrorUrl?: UrlOperator | null;
  firstMeaningfulPaint?: DurationOperator | null;
  pageLoad?: DurationOperator | null;
  domContentLoaded?: DurationOperator | null;
  seen?: ElementOperator | null;
  thrashedCursor?: NoneOperator | null;
  crashed?: NoneOperator | null;
  abandonedForm?: AbandonedOperator | null;
  navigatedToScreen?: StringOperator | null;
  custom?: CustomEventOperator | null;
  customError?: ApiErrorOperator | null;
  userError?: ApiErrorOperator | null;
  definedEvent?: DefinedEventOperator | null;
  eventSet?: EventSetOperator | null;
  lowMemory?: NoneOperator | null;
  pageError?: ApiErrorOperator | null;
  pinchGesture?: NoneOperator | null;
  uncaughtException?: StringOperator | null;
  pageRefresh?: UrlOperator | null;
  dataloss?: DatalossOperator | null;
  highlight?: ElementOperator | null;
  copy?: ElementOperator | null;
  paste?: ElementOperator | null;
  visitedPage?: PageRefOperator | null;
  seenError?: ApiErrorOperator | null;
  consoleError?: StringOperator | null;
  cumulativeLayoutShift?: FloatOperator | null;
  firstInputDelay?: DurationOperator | null;
  largestContentfulPaint?: DurationOperator | null;
  keepSignal?: NoneOperator | null;
  elemError?: ApiErrorOperator | null;
  specEvent?: SpecEventOperator | null;
  appForcedRestart?: NoneOperator | null;
  interactionToNextPaint?: DurationOperator | null;
  timeToInteractive?: DurationOperator | null;
  totalBlockingTime?: DurationOperator | null;
  timeToFirstByte?: DurationOperator | null;
  backgrounded?: NoneOperator | null;
  suspiciousActivitySignal?: SuspiciousActivityOperator | null;
}

export namespace EventFilter {
  export enum filter {
    click = 1,
    change = 2,
    rageClick = 3,
    errorClick = 4,
    deadClick = 5,
    suspiciousActivity = 6,
    visitedUrl = 7,
    ajaxErrorUrl = 8,
    firstMeaningfulPaint = 9,
    pageLoad = 10,
    domContentLoaded = 11,
    seen = 12,
    thrashedCursor = 13,
    crashed = 14,
    abandonedForm = 15,
    navigatedToScreen = 16,
    custom = 17,
    customError = 18,
    userError = 19,
    definedEvent = 20,
    eventSet = 22,
    lowMemory = 23,
    pageError = 24,
    pinchGesture = 25,
    uncaughtException = 26,
    pageRefresh = 27,
    dataloss = 28,
    highlight = 29,
    copy = 30,
    paste = 31,
    visitedPage = 32,
    seenError = 33,
    consoleError = 34,
    cumulativeLayoutShift = 35,
    firstInputDelay = 36,
    largestContentfulPaint = 37,
    keepSignal = 38,
    elemError = 39,
    specEvent = 40,
    appForcedRestart = 41,
    interactionToNextPaint = 42,
    timeToInteractive = 43,
    totalBlockingTime = 44,
    timeToFirstByte = 45,
    backgrounded = 46,
    suspiciousActivitySignal = 47
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum filter_keys {
    click = 'click',
    change = 'change',
    rageClick = 'rageClick',
    errorClick = 'errorClick',
    deadClick = 'deadClick',
    suspiciousActivity = 'suspiciousActivity',
    visitedUrl = 'visitedUrl',
    ajaxErrorUrl = 'ajaxErrorUrl',
    firstMeaningfulPaint = 'firstMeaningfulPaint',
    pageLoad = 'pageLoad',
    domContentLoaded = 'domContentLoaded',
    seen = 'seen',
    thrashedCursor = 'thrashedCursor',
    crashed = 'crashed',
    abandonedForm = 'abandonedForm',
    navigatedToScreen = 'navigatedToScreen',
    custom = 'custom',
    customError = 'customError',
    userError = 'userError',
    definedEvent = 'definedEvent',
    eventSet = 'eventSet',
    lowMemory = 'lowMemory',
    pageError = 'pageError',
    pinchGesture = 'pinchGesture',
    uncaughtException = 'uncaughtException',
    pageRefresh = 'pageRefresh',
    dataloss = 'dataloss',
    highlight = 'highlight',
    copy = 'copy',
    paste = 'paste',
    visitedPage = 'visitedPage',
    seenError = 'seenError',
    consoleError = 'consoleError',
    cumulativeLayoutShift = 'cumulativeLayoutShift',
    firstInputDelay = 'firstInputDelay',
    largestContentfulPaint = 'largestContentfulPaint',
    keepSignal = 'keepSignal',
    elemError = 'elemError',
    specEvent = 'specEvent',
    appForcedRestart = 'appForcedRestart',
    interactionToNextPaint = 'interactionToNextPaint',
    timeToInteractive = 'timeToInteractive',
    totalBlockingTime = 'totalBlockingTime',
    timeToFirstByte = 'timeToFirstByte',
    backgrounded = 'backgrounded',
    suspiciousActivitySignal = 'suspiciousActivitySignal'
  }

  export function filter_oneof(m: EventFilter): { opt: filter.abandonedForm, key: filter_keys.abandonedForm, val: AbandonedOperator } | { opt: filter.ajaxErrorUrl, key: filter_keys.ajaxErrorUrl, val: UrlOperator } | { opt: filter.appForcedRestart, key: filter_keys.appForcedRestart, val: NoneOperator } | { opt: filter.backgrounded, key: filter_keys.backgrounded, val: NoneOperator } | { opt: filter.change, key: filter_keys.change, val: ElementOperator } | { opt: filter.click, key: filter_keys.click, val: ElementOperator } | { opt: filter.consoleError, key: filter_keys.consoleError, val: StringOperator } | { opt: filter.copy, key: filter_keys.copy, val: ElementOperator } | { opt: filter.crashed, key: filter_keys.crashed, val: NoneOperator } | { opt: filter.cumulativeLayoutShift, key: filter_keys.cumulativeLayoutShift, val: FloatOperator } | { opt: filter.custom, key: filter_keys.custom, val: CustomEventOperator } | { opt: filter.customError, key: filter_keys.customError, val: ApiErrorOperator } | { opt: filter.dataloss, key: filter_keys.dataloss, val: DatalossOperator } | { opt: filter.deadClick, key: filter_keys.deadClick, val: ElementOperator } | { opt: filter.definedEvent, key: filter_keys.definedEvent, val: DefinedEventOperator } | { opt: filter.domContentLoaded, key: filter_keys.domContentLoaded, val: DurationOperator } | { opt: filter.elemError, key: filter_keys.elemError, val: ApiErrorOperator } | { opt: filter.errorClick, key: filter_keys.errorClick, val: ElementOperator } | { opt: filter.eventSet, key: filter_keys.eventSet, val: EventSetOperator } | { opt: filter.firstInputDelay, key: filter_keys.firstInputDelay, val: DurationOperator } | { opt: filter.firstMeaningfulPaint, key: filter_keys.firstMeaningfulPaint, val: DurationOperator } | { opt: filter.highlight, key: filter_keys.highlight, val: ElementOperator } | { opt: filter.interactionToNextPaint, key: filter_keys.interactionToNextPaint, val: DurationOperator } | { opt: filter.keepSignal, key: filter_keys.keepSignal, val: NoneOperator } | { opt: filter.largestContentfulPaint, key: filter_keys.largestContentfulPaint, val: DurationOperator } | { opt: filter.lowMemory, key: filter_keys.lowMemory, val: NoneOperator } | { opt: filter.navigatedToScreen, key: filter_keys.navigatedToScreen, val: StringOperator } | { opt: filter.pageError, key: filter_keys.pageError, val: ApiErrorOperator } | { opt: filter.pageLoad, key: filter_keys.pageLoad, val: DurationOperator } | { opt: filter.pageRefresh, key: filter_keys.pageRefresh, val: UrlOperator } | { opt: filter.paste, key: filter_keys.paste, val: ElementOperator } | { opt: filter.pinchGesture, key: filter_keys.pinchGesture, val: NoneOperator } | { opt: filter.rageClick, key: filter_keys.rageClick, val: ElementOperator } | { opt: filter.seen, key: filter_keys.seen, val: ElementOperator } | { opt: filter.seenError, key: filter_keys.seenError, val: ApiErrorOperator } | { opt: filter.specEvent, key: filter_keys.specEvent, val: SpecEventOperator } | { opt: filter.suspiciousActivity, key: filter_keys.suspiciousActivity, val: ElementOperator } | { opt: filter.suspiciousActivitySignal, key: filter_keys.suspiciousActivitySignal, val: SuspiciousActivityOperator } | { opt: filter.thrashedCursor, key: filter_keys.thrashedCursor, val: NoneOperator } | { opt: filter.timeToFirstByte, key: filter_keys.timeToFirstByte, val: DurationOperator } | { opt: filter.timeToInteractive, key: filter_keys.timeToInteractive, val: DurationOperator } | { opt: filter.totalBlockingTime, key: filter_keys.totalBlockingTime, val: DurationOperator } | { opt: filter.uncaughtException, key: filter_keys.uncaughtException, val: StringOperator } | { opt: filter.userError, key: filter_keys.userError, val: ApiErrorOperator } | { opt: filter.visitedPage, key: filter_keys.visitedPage, val: PageRefOperator } | { opt: filter.visitedUrl, key: filter_keys.visitedUrl, val: UrlOperator } | null {
    if (m.click != null) { return { opt: filter.click, key: filter_keys.click, val: m.click } }
    if (m.change != null) { return { opt: filter.change, key: filter_keys.change, val: m.change } }
    if (m.rageClick != null) { return { opt: filter.rageClick, key: filter_keys.rageClick, val: m.rageClick } }
    if (m.errorClick != null) { return { opt: filter.errorClick, key: filter_keys.errorClick, val: m.errorClick } }
    if (m.deadClick != null) { return { opt: filter.deadClick, key: filter_keys.deadClick, val: m.deadClick } }
    if (m.suspiciousActivity != null) { return { opt: filter.suspiciousActivity, key: filter_keys.suspiciousActivity, val: m.suspiciousActivity } }
    if (m.visitedUrl != null) { return { opt: filter.visitedUrl, key: filter_keys.visitedUrl, val: m.visitedUrl } }
    if (m.ajaxErrorUrl != null) { return { opt: filter.ajaxErrorUrl, key: filter_keys.ajaxErrorUrl, val: m.ajaxErrorUrl } }
    if (m.firstMeaningfulPaint != null) { return { opt: filter.firstMeaningfulPaint, key: filter_keys.firstMeaningfulPaint, val: m.firstMeaningfulPaint } }
    if (m.pageLoad != null) { return { opt: filter.pageLoad, key: filter_keys.pageLoad, val: m.pageLoad } }
    if (m.domContentLoaded != null) { return { opt: filter.domContentLoaded, key: filter_keys.domContentLoaded, val: m.domContentLoaded } }
    if (m.seen != null) { return { opt: filter.seen, key: filter_keys.seen, val: m.seen } }
    if (m.thrashedCursor != null) { return { opt: filter.thrashedCursor, key: filter_keys.thrashedCursor, val: m.thrashedCursor } }
    if (m.crashed != null) { return { opt: filter.crashed, key: filter_keys.crashed, val: m.crashed } }
    if (m.abandonedForm != null) { return { opt: filter.abandonedForm, key: filter_keys.abandonedForm, val: m.abandonedForm } }
    if (m.navigatedToScreen != null) { return { opt: filter.navigatedToScreen, key: filter_keys.navigatedToScreen, val: m.navigatedToScreen } }
    if (m.custom != null) { return { opt: filter.custom, key: filter_keys.custom, val: m.custom } }
    if (m.customError != null) { return { opt: filter.customError, key: filter_keys.customError, val: m.customError } }
    if (m.userError != null) { return { opt: filter.userError, key: filter_keys.userError, val: m.userError } }
    if (m.definedEvent != null) { return { opt: filter.definedEvent, key: filter_keys.definedEvent, val: m.definedEvent } }
    if (m.eventSet != null) { return { opt: filter.eventSet, key: filter_keys.eventSet, val: m.eventSet } }
    if (m.lowMemory != null) { return { opt: filter.lowMemory, key: filter_keys.lowMemory, val: m.lowMemory } }
    if (m.pageError != null) { return { opt: filter.pageError, key: filter_keys.pageError, val: m.pageError } }
    if (m.pinchGesture != null) { return { opt: filter.pinchGesture, key: filter_keys.pinchGesture, val: m.pinchGesture } }
    if (m.uncaughtException != null) { return { opt: filter.uncaughtException, key: filter_keys.uncaughtException, val: m.uncaughtException } }
    if (m.pageRefresh != null) { return { opt: filter.pageRefresh, key: filter_keys.pageRefresh, val: m.pageRefresh } }
    if (m.dataloss != null) { return { opt: filter.dataloss, key: filter_keys.dataloss, val: m.dataloss } }
    if (m.highlight != null) { return { opt: filter.highlight, key: filter_keys.highlight, val: m.highlight } }
    if (m.copy != null) { return { opt: filter.copy, key: filter_keys.copy, val: m.copy } }
    if (m.paste != null) { return { opt: filter.paste, key: filter_keys.paste, val: m.paste } }
    if (m.visitedPage != null) { return { opt: filter.visitedPage, key: filter_keys.visitedPage, val: m.visitedPage } }
    if (m.seenError != null) { return { opt: filter.seenError, key: filter_keys.seenError, val: m.seenError } }
    if (m.consoleError != null) { return { opt: filter.consoleError, key: filter_keys.consoleError, val: m.consoleError } }
    if (m.cumulativeLayoutShift != null) { return { opt: filter.cumulativeLayoutShift, key: filter_keys.cumulativeLayoutShift, val: m.cumulativeLayoutShift } }
    if (m.firstInputDelay != null) { return { opt: filter.firstInputDelay, key: filter_keys.firstInputDelay, val: m.firstInputDelay } }
    if (m.largestContentfulPaint != null) { return { opt: filter.largestContentfulPaint, key: filter_keys.largestContentfulPaint, val: m.largestContentfulPaint } }
    if (m.keepSignal != null) { return { opt: filter.keepSignal, key: filter_keys.keepSignal, val: m.keepSignal } }
    if (m.elemError != null) { return { opt: filter.elemError, key: filter_keys.elemError, val: m.elemError } }
    if (m.specEvent != null) { return { opt: filter.specEvent, key: filter_keys.specEvent, val: m.specEvent } }
    if (m.appForcedRestart != null) { return { opt: filter.appForcedRestart, key: filter_keys.appForcedRestart, val: m.appForcedRestart } }
    if (m.interactionToNextPaint != null) { return { opt: filter.interactionToNextPaint, key: filter_keys.interactionToNextPaint, val: m.interactionToNextPaint } }
    if (m.timeToInteractive != null) { return { opt: filter.timeToInteractive, key: filter_keys.timeToInteractive, val: m.timeToInteractive } }
    if (m.totalBlockingTime != null) { return { opt: filter.totalBlockingTime, key: filter_keys.totalBlockingTime, val: m.totalBlockingTime } }
    if (m.timeToFirstByte != null) { return { opt: filter.timeToFirstByte, key: filter_keys.timeToFirstByte, val: m.timeToFirstByte } }
    if (m.backgrounded != null) { return { opt: filter.backgrounded, key: filter_keys.backgrounded, val: m.backgrounded } }
    if (m.suspiciousActivitySignal != null) { return { opt: filter.suspiciousActivitySignal, key: filter_keys.suspiciousActivitySignal, val: m.suspiciousActivitySignal } }
    return null;
  }
}

export interface DependentEventFilter {
  city?: StringOperator | null;
  region?: StringOperator | null;
  country?: StringOperator | null;
  email?: StringOperator | null;
  name?: StringOperator | null;
  signedUp?: SignedUpOperator | null;
  userId?: StringOperator | null;
  userAgent?: StringOperator | null;
  appViewName?: StringOperator | null;
  appPackageName?: StringOperator | null;
  appName?: StringOperator | null;
  deviceModel?: StringOperator | null;
  deviceVendor?: StringOperator | null;
  browser?: BrowserOperator | null;
  device?: DeviceOperator | null;
  platform?: PlatformOperator | null;
  nativePlatform?: NativePlatformOperator | null;
  os?: OSOperator | null;
  pageDuration?: DurationOperator | null;
  pageActiveDuration?: DurationOperator | null;
  ipAddress?: StringRangeOperator | null;
  appVersion?: StringRangeOperator | null;
  appOsVersion?: StringRangeOperator | null;
  appFsVersion?: StringRangeOperator | null;
  timeSincePageLoad?: DurationOperator | null;
  timeSinceSessionStart?: DurationOperator | null;
  consoleErrorsOnPage?: NumericOperator | null;
  consoleWarningsOnPage?: NumericOperator | null;
  displayWidth?: NumericOperator | null;
  displayHeight?: NumericOperator | null;
  viewportWidth?: NumericOperator | null;
  viewportHeight?: NumericOperator | null;
  referrerUrl?: UrlOperator | null;
  url?: UrlOperator | null;
  /** Only allowed if parent primary is ElementOperator.css/ElementOperator.with_element_id */
  text?: TextOperator | null;
  /** Only allowed if parent primary is ElementOperator.text */
  css?: CssOperator | null;
  /** Only allowed if parent primary is ElementOperator.text */
  element?: ElementIdOperator | null;
  elemVarString?: CustomFieldStringOperator | null;
  elemVarFloat?: CustomFieldFloatOperator | null;
  elemVarInt?: CustomFieldIntOperator | null;
  elemVarBool?: CustomFieldBoolOperator | null;
  elemVarDate?: CustomFieldDateOperator | null;
  elemVarStrings?: CustomFieldStringsOperator | null;
  elemVarFloats?: CustomFieldFloatsOperator | null;
  elemVarInts?: CustomFieldIntsOperator | null;
  elemVarDates?: CustomFieldDatesOperator | null;
  elemVarBools?: CustomFieldBoolsOperator | null;
  userVarString?: CustomFieldStringOperator | null;
  userVarFloat?: CustomFieldFloatOperator | null;
  userVarInt?: CustomFieldIntOperator | null;
  userVarBool?: CustomFieldBoolOperator | null;
  userVarDate?: CustomFieldDateOperator | null;
  customEventPropertyString?: CustomFieldStringOperator | null;
  customEventPropertyFloat?: CustomFieldFloatOperator | null;
  customEventPropertyInt?: CustomFieldIntOperator | null;
  customEventPropertyBool?: CustomFieldBoolOperator | null;
  customEventPropertyDate?: CustomFieldDateOperator | null;
  /** hidden from UI, only used for dimensionality */
  apiEventName?: CustomEventOperator | null;
  /** Only allowed if parent primary is custom_error, user_error, page_error, elem_error */
  customApiErrorProperty?: StringOperator | null;
  userVarStrings?: CustomFieldStringsOperator | null;
  userVarFloats?: CustomFieldFloatsOperator | null;
  userVarInts?: CustomFieldIntsOperator | null;
  customEventPropertyStrings?: CustomFieldStringsOperator | null;
  customEventPropertyFloats?: CustomFieldFloatsOperator | null;
  customEventPropertyInts?: CustomFieldIntsOperator | null;
  userVarDates?: CustomFieldDatesOperator | null;
  userVarBools?: CustomFieldBoolsOperator | null;
  customEventPropertyDates?: CustomFieldDatesOperator | null;
  customEventPropertyBools?: CustomFieldBoolsOperator | null;
  /** fs only operators, not visible through UI */
  fsUserId?: NumericIdOperator | null;
  fsPageClusterId?: NumericIdOperator | null;
  fsSessionId?: NumericIdOperator | null;
  pageName?: StringOperator | null;
  pageVarString?: CustomFieldStringOperator | null;
  pageVarFloat?: CustomFieldFloatOperator | null;
  pageVarInt?: CustomFieldIntOperator | null;
  pageVarBool?: CustomFieldBoolOperator | null;
  pageVarDate?: CustomFieldDateOperator | null;
  pageVarStrings?: CustomFieldStringsOperator | null;
  pageVarFloats?: CustomFieldFloatsOperator | null;
  pageVarInts?: CustomFieldIntsOperator | null;
  pageVarDates?: CustomFieldDatesOperator | null;
  pageVarBools?: CustomFieldBoolsOperator | null;
  /** Only allowed if parent primary is ajax_error_url */
  requestMethod?: StringOperator | null;
  /** Only allowed if parent primary is ajax_error_url */
  statusCode?: NumericOperator | null;
  /** Only allowed if parent primary is pinch_gesture */
  pinchGestureType?: PinchGestureOperator | null;
  /** Only allowed if parent primary is uncaught_exception on web */
  webSourceFileUrl?: UrlOperator | null;
  /** Only allowed if parent primary is uncaught_exception on mobile */
  mobileSourceFile?: StringOperator | null;
  /** Only allowed if parent primary is visitedUrl */
  scrollDepth?: NumericOperator | null;
  /** Only allowed if parent primary is seen */
  seenVisibility?: SeenVisibilityOperator | null;
  /** Only allowed if parent primary is seen */
  timeDurationRendered?: DurationOperator | null;
  /** Only allowed if parent primary is seen */
  timeDurationVisible?: DurationOperator | null;
  pageDefId?: PageRefOperator | null;
  prevPageDefId?: PageRefOperator | null;
  sessionEntryPage?: BoolOperator | null;
  sessionExitPage?: BoolOperator | null;
  /** Only allowed if parent primary is error click */
  errorClickType?: ErrorClickTypeOperator | null;
  browserVersion?: StringRangeOperator | null;
  ajaxRequestUrl?: UrlOperator | null;
  start?: DateOperator | null;
  sessionStart?: DateOperator | null;
  /** Only allowed if parent primary is dataloss */
  datalossType?: DatalossTypeOperator | null;
  datalossOrigin?: DatalossOriginOperator | null;
  pageviewTotalDuration?: DurationOperator | null;
  pageviewActiveDuration?: DurationOperator | null;
  pageviewInactiveDuration?: DurationOperator | null;
  /** Hidden from UI, only used for Journeys API */
  definedEvent?: DefinedEventOperator | null;
  sessionType?: SessionTypeOperator | null;
  dependentSet?: DependentEventSetOperator | null;
  /** Explicitly matches no events. */
  none?: NoneOperator | null;
  fsevtVarFloat?: CustomFieldFloatOperator | null;
  fsevtVarInt?: CustomFieldIntOperator | null;
  fsevtVarString?: CustomFieldStringOperator | null;
  fsevtVarBool?: CustomFieldBoolOperator | null;
  fsevtVarDate?: CustomFieldDateOperator | null;
  fsevtVarFloats?: CustomFieldFloatsOperator | null;
  fsevtVarInts?: CustomFieldIntsOperator | null;
  fsevtVarStrings?: CustomFieldStringsOperator | null;
  fsevtVarDates?: CustomFieldDatesOperator | null;
  fsevtVarBools?: CustomFieldBoolsOperator | null;
  /** Only allowed if parent primary is suspicious_activity */
  suspiciousActivityType?: SuspiciousActivityTypeOperator | null;
  /** Only allowed if parent primary is suspicious_activity */
  suspiciousActivityCategory?: SuspiciousActivityCategoryOperator | null;
}

export namespace DependentEventFilter {
  export enum filter {
    city = 1,
    region = 2,
    country = 3,
    email = 4,
    name = 5,
    signedUp = 93,
    userId = 94,
    userAgent = 6,
    appViewName = 7,
    appPackageName = 73,
    appName = 95,
    deviceModel = 8,
    deviceVendor = 9,
    browser = 10,
    device = 11,
    platform = 12,
    nativePlatform = 108,
    os = 13,
    pageDuration = 14,
    pageActiveDuration = 15,
    ipAddress = 16,
    appVersion = 17,
    appOsVersion = 18,
    appFsVersion = 92,
    timeSincePageLoad = 19,
    timeSinceSessionStart = 20,
    consoleErrorsOnPage = 21,
    consoleWarningsOnPage = 22,
    displayWidth = 23,
    displayHeight = 24,
    viewportWidth = 25,
    viewportHeight = 26,
    referrerUrl = 27,
    url = 28,
    /** Only allowed if parent primary is ElementOperator.css/ElementOperator.with_element_id */
    text = 29,
    /** Only allowed if parent primary is ElementOperator.text */
    css = 30,
    /** Only allowed if parent primary is ElementOperator.text */
    element = 55,
    elemVarString = 98,
    elemVarFloat = 99,
    elemVarInt = 100,
    elemVarBool = 101,
    elemVarDate = 102,
    elemVarStrings = 103,
    elemVarFloats = 104,
    elemVarInts = 105,
    elemVarDates = 106,
    elemVarBools = 107,
    userVarString = 31,
    userVarFloat = 32,
    userVarInt = 33,
    userVarBool = 34,
    userVarDate = 35,
    customEventPropertyString = 36,
    customEventPropertyFloat = 37,
    customEventPropertyInt = 38,
    customEventPropertyBool = 39,
    customEventPropertyDate = 40,
    /** hidden from UI, only used for dimensionality */
    apiEventName = 97,
    /** Only allowed if parent primary is custom_error, user_error, page_error, elem_error */
    customApiErrorProperty = 41,
    userVarStrings = 42,
    userVarFloats = 43,
    userVarInts = 44,
    customEventPropertyStrings = 45,
    customEventPropertyFloats = 46,
    customEventPropertyInts = 47,
    userVarDates = 49,
    userVarBools = 50,
    customEventPropertyDates = 51,
    customEventPropertyBools = 52,
    /** fs only operators, not visible through UI */
    fsUserId = 53,
    fsPageClusterId = 54,
    fsSessionId = 121,
    pageName = 56,
    pageVarString = 57,
    pageVarFloat = 58,
    pageVarInt = 59,
    pageVarBool = 60,
    pageVarDate = 61,
    pageVarStrings = 62,
    pageVarFloats = 63,
    pageVarInts = 64,
    pageVarDates = 65,
    pageVarBools = 66,
    /** Only allowed if parent primary is ajax_error_url */
    requestMethod = 67,
    /** Only allowed if parent primary is ajax_error_url */
    statusCode = 68,
    /** Only allowed if parent primary is pinch_gesture */
    pinchGestureType = 69,
    /** Only allowed if parent primary is uncaught_exception on web */
    webSourceFileUrl = 70,
    /** Only allowed if parent primary is uncaught_exception on mobile */
    mobileSourceFile = 71,
    /** Only allowed if parent primary is visitedUrl */
    scrollDepth = 72,
    /** Only allowed if parent primary is seen */
    seenVisibility = 74,
    /** Only allowed if parent primary is seen */
    timeDurationRendered = 75,
    /** Only allowed if parent primary is seen */
    timeDurationVisible = 76,
    pageDefId = 77,
    prevPageDefId = 81,
    sessionEntryPage = 79,
    sessionExitPage = 80,
    /** Only allowed if parent primary is error click */
    errorClickType = 82,
    browserVersion = 83,
    ajaxRequestUrl = 84,
    start = 48,
    sessionStart = 85,
    /** Only allowed if parent primary is dataloss */
    datalossType = 86,
    datalossOrigin = 87,
    pageviewTotalDuration = 88,
    pageviewActiveDuration = 89,
    pageviewInactiveDuration = 90,
    /** Hidden from UI, only used for Journeys API */
    definedEvent = 91,
    sessionType = 96,
    dependentSet = 109,
    /** Explicitly matches no events. */
    none = 110,
    fsevtVarFloat = 111,
    fsevtVarInt = 112,
    fsevtVarString = 113,
    fsevtVarBool = 114,
    fsevtVarDate = 115,
    fsevtVarFloats = 116,
    fsevtVarInts = 117,
    fsevtVarStrings = 118,
    fsevtVarDates = 119,
    fsevtVarBools = 120,
    /** Only allowed if parent primary is suspicious_activity */
    suspiciousActivityType = 122,
    /** Only allowed if parent primary is suspicious_activity */
    suspiciousActivityCategory = 123
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum filter_keys {
    city = 'city',
    region = 'region',
    country = 'country',
    email = 'email',
    name = 'name',
    signedUp = 'signedUp',
    userId = 'userId',
    userAgent = 'userAgent',
    appViewName = 'appViewName',
    appPackageName = 'appPackageName',
    appName = 'appName',
    deviceModel = 'deviceModel',
    deviceVendor = 'deviceVendor',
    browser = 'browser',
    device = 'device',
    platform = 'platform',
    nativePlatform = 'nativePlatform',
    os = 'os',
    pageDuration = 'pageDuration',
    pageActiveDuration = 'pageActiveDuration',
    ipAddress = 'ipAddress',
    appVersion = 'appVersion',
    appOsVersion = 'appOsVersion',
    appFsVersion = 'appFsVersion',
    timeSincePageLoad = 'timeSincePageLoad',
    timeSinceSessionStart = 'timeSinceSessionStart',
    consoleErrorsOnPage = 'consoleErrorsOnPage',
    consoleWarningsOnPage = 'consoleWarningsOnPage',
    displayWidth = 'displayWidth',
    displayHeight = 'displayHeight',
    viewportWidth = 'viewportWidth',
    viewportHeight = 'viewportHeight',
    referrerUrl = 'referrerUrl',
    url = 'url',
    /** Only allowed if parent primary is ElementOperator.css/ElementOperator.with_element_id */
    text = 'text',
    /** Only allowed if parent primary is ElementOperator.text */
    css = 'css',
    /** Only allowed if parent primary is ElementOperator.text */
    element = 'element',
    elemVarString = 'elemVarString',
    elemVarFloat = 'elemVarFloat',
    elemVarInt = 'elemVarInt',
    elemVarBool = 'elemVarBool',
    elemVarDate = 'elemVarDate',
    elemVarStrings = 'elemVarStrings',
    elemVarFloats = 'elemVarFloats',
    elemVarInts = 'elemVarInts',
    elemVarDates = 'elemVarDates',
    elemVarBools = 'elemVarBools',
    userVarString = 'userVarString',
    userVarFloat = 'userVarFloat',
    userVarInt = 'userVarInt',
    userVarBool = 'userVarBool',
    userVarDate = 'userVarDate',
    customEventPropertyString = 'customEventPropertyString',
    customEventPropertyFloat = 'customEventPropertyFloat',
    customEventPropertyInt = 'customEventPropertyInt',
    customEventPropertyBool = 'customEventPropertyBool',
    customEventPropertyDate = 'customEventPropertyDate',
    /** hidden from UI, only used for dimensionality */
    apiEventName = 'apiEventName',
    /** Only allowed if parent primary is custom_error, user_error, page_error, elem_error */
    customApiErrorProperty = 'customApiErrorProperty',
    userVarStrings = 'userVarStrings',
    userVarFloats = 'userVarFloats',
    userVarInts = 'userVarInts',
    customEventPropertyStrings = 'customEventPropertyStrings',
    customEventPropertyFloats = 'customEventPropertyFloats',
    customEventPropertyInts = 'customEventPropertyInts',
    userVarDates = 'userVarDates',
    userVarBools = 'userVarBools',
    customEventPropertyDates = 'customEventPropertyDates',
    customEventPropertyBools = 'customEventPropertyBools',
    /** fs only operators, not visible through UI */
    fsUserId = 'fsUserId',
    fsPageClusterId = 'fsPageClusterId',
    fsSessionId = 'fsSessionId',
    pageName = 'pageName',
    pageVarString = 'pageVarString',
    pageVarFloat = 'pageVarFloat',
    pageVarInt = 'pageVarInt',
    pageVarBool = 'pageVarBool',
    pageVarDate = 'pageVarDate',
    pageVarStrings = 'pageVarStrings',
    pageVarFloats = 'pageVarFloats',
    pageVarInts = 'pageVarInts',
    pageVarDates = 'pageVarDates',
    pageVarBools = 'pageVarBools',
    /** Only allowed if parent primary is ajax_error_url */
    requestMethod = 'requestMethod',
    /** Only allowed if parent primary is ajax_error_url */
    statusCode = 'statusCode',
    /** Only allowed if parent primary is pinch_gesture */
    pinchGestureType = 'pinchGestureType',
    /** Only allowed if parent primary is uncaught_exception on web */
    webSourceFileUrl = 'webSourceFileUrl',
    /** Only allowed if parent primary is uncaught_exception on mobile */
    mobileSourceFile = 'mobileSourceFile',
    /** Only allowed if parent primary is visitedUrl */
    scrollDepth = 'scrollDepth',
    /** Only allowed if parent primary is seen */
    seenVisibility = 'seenVisibility',
    /** Only allowed if parent primary is seen */
    timeDurationRendered = 'timeDurationRendered',
    /** Only allowed if parent primary is seen */
    timeDurationVisible = 'timeDurationVisible',
    pageDefId = 'pageDefId',
    prevPageDefId = 'prevPageDefId',
    sessionEntryPage = 'sessionEntryPage',
    sessionExitPage = 'sessionExitPage',
    /** Only allowed if parent primary is error click */
    errorClickType = 'errorClickType',
    browserVersion = 'browserVersion',
    ajaxRequestUrl = 'ajaxRequestUrl',
    start = 'start',
    sessionStart = 'sessionStart',
    /** Only allowed if parent primary is dataloss */
    datalossType = 'datalossType',
    datalossOrigin = 'datalossOrigin',
    pageviewTotalDuration = 'pageviewTotalDuration',
    pageviewActiveDuration = 'pageviewActiveDuration',
    pageviewInactiveDuration = 'pageviewInactiveDuration',
    /** Hidden from UI, only used for Journeys API */
    definedEvent = 'definedEvent',
    sessionType = 'sessionType',
    dependentSet = 'dependentSet',
    /** Explicitly matches no events. */
    none = 'none',
    fsevtVarFloat = 'fsevtVarFloat',
    fsevtVarInt = 'fsevtVarInt',
    fsevtVarString = 'fsevtVarString',
    fsevtVarBool = 'fsevtVarBool',
    fsevtVarDate = 'fsevtVarDate',
    fsevtVarFloats = 'fsevtVarFloats',
    fsevtVarInts = 'fsevtVarInts',
    fsevtVarStrings = 'fsevtVarStrings',
    fsevtVarDates = 'fsevtVarDates',
    fsevtVarBools = 'fsevtVarBools',
    /** Only allowed if parent primary is suspicious_activity */
    suspiciousActivityType = 'suspiciousActivityType',
    /** Only allowed if parent primary is suspicious_activity */
    suspiciousActivityCategory = 'suspiciousActivityCategory'
  }

  export function filter_oneof(m: DependentEventFilter): { opt: filter.ajaxRequestUrl, key: filter_keys.ajaxRequestUrl, val: UrlOperator } | { opt: filter.apiEventName, key: filter_keys.apiEventName, val: CustomEventOperator } | { opt: filter.appFsVersion, key: filter_keys.appFsVersion, val: StringRangeOperator } | { opt: filter.appName, key: filter_keys.appName, val: StringOperator } | { opt: filter.appOsVersion, key: filter_keys.appOsVersion, val: StringRangeOperator } | { opt: filter.appPackageName, key: filter_keys.appPackageName, val: StringOperator } | { opt: filter.appVersion, key: filter_keys.appVersion, val: StringRangeOperator } | { opt: filter.appViewName, key: filter_keys.appViewName, val: StringOperator } | { opt: filter.browser, key: filter_keys.browser, val: BrowserOperator } | { opt: filter.browserVersion, key: filter_keys.browserVersion, val: StringRangeOperator } | { opt: filter.city, key: filter_keys.city, val: StringOperator } | { opt: filter.consoleErrorsOnPage, key: filter_keys.consoleErrorsOnPage, val: NumericOperator } | { opt: filter.consoleWarningsOnPage, key: filter_keys.consoleWarningsOnPage, val: NumericOperator } | { opt: filter.country, key: filter_keys.country, val: StringOperator } | { opt: filter.css, key: filter_keys.css, val: CssOperator } | { opt: filter.customApiErrorProperty, key: filter_keys.customApiErrorProperty, val: StringOperator } | { opt: filter.customEventPropertyBool, key: filter_keys.customEventPropertyBool, val: CustomFieldBoolOperator } | { opt: filter.customEventPropertyBools, key: filter_keys.customEventPropertyBools, val: CustomFieldBoolsOperator } | { opt: filter.customEventPropertyDate, key: filter_keys.customEventPropertyDate, val: CustomFieldDateOperator } | { opt: filter.customEventPropertyDates, key: filter_keys.customEventPropertyDates, val: CustomFieldDatesOperator } | { opt: filter.customEventPropertyFloat, key: filter_keys.customEventPropertyFloat, val: CustomFieldFloatOperator } | { opt: filter.customEventPropertyFloats, key: filter_keys.customEventPropertyFloats, val: CustomFieldFloatsOperator } | { opt: filter.customEventPropertyInt, key: filter_keys.customEventPropertyInt, val: CustomFieldIntOperator } | { opt: filter.customEventPropertyInts, key: filter_keys.customEventPropertyInts, val: CustomFieldIntsOperator } | { opt: filter.customEventPropertyString, key: filter_keys.customEventPropertyString, val: CustomFieldStringOperator } | { opt: filter.customEventPropertyStrings, key: filter_keys.customEventPropertyStrings, val: CustomFieldStringsOperator } | { opt: filter.datalossOrigin, key: filter_keys.datalossOrigin, val: DatalossOriginOperator } | { opt: filter.datalossType, key: filter_keys.datalossType, val: DatalossTypeOperator } | { opt: filter.definedEvent, key: filter_keys.definedEvent, val: DefinedEventOperator } | { opt: filter.dependentSet, key: filter_keys.dependentSet, val: DependentEventSetOperator } | { opt: filter.device, key: filter_keys.device, val: DeviceOperator } | { opt: filter.deviceModel, key: filter_keys.deviceModel, val: StringOperator } | { opt: filter.deviceVendor, key: filter_keys.deviceVendor, val: StringOperator } | { opt: filter.displayHeight, key: filter_keys.displayHeight, val: NumericOperator } | { opt: filter.displayWidth, key: filter_keys.displayWidth, val: NumericOperator } | { opt: filter.elemVarBool, key: filter_keys.elemVarBool, val: CustomFieldBoolOperator } | { opt: filter.elemVarBools, key: filter_keys.elemVarBools, val: CustomFieldBoolsOperator } | { opt: filter.elemVarDate, key: filter_keys.elemVarDate, val: CustomFieldDateOperator } | { opt: filter.elemVarDates, key: filter_keys.elemVarDates, val: CustomFieldDatesOperator } | { opt: filter.elemVarFloat, key: filter_keys.elemVarFloat, val: CustomFieldFloatOperator } | { opt: filter.elemVarFloats, key: filter_keys.elemVarFloats, val: CustomFieldFloatsOperator } | { opt: filter.elemVarInt, key: filter_keys.elemVarInt, val: CustomFieldIntOperator } | { opt: filter.elemVarInts, key: filter_keys.elemVarInts, val: CustomFieldIntsOperator } | { opt: filter.elemVarString, key: filter_keys.elemVarString, val: CustomFieldStringOperator } | { opt: filter.elemVarStrings, key: filter_keys.elemVarStrings, val: CustomFieldStringsOperator } | { opt: filter.element, key: filter_keys.element, val: ElementIdOperator } | { opt: filter.email, key: filter_keys.email, val: StringOperator } | { opt: filter.errorClickType, key: filter_keys.errorClickType, val: ErrorClickTypeOperator } | { opt: filter.fsPageClusterId, key: filter_keys.fsPageClusterId, val: NumericIdOperator } | { opt: filter.fsSessionId, key: filter_keys.fsSessionId, val: NumericIdOperator } | { opt: filter.fsUserId, key: filter_keys.fsUserId, val: NumericIdOperator } | { opt: filter.fsevtVarBool, key: filter_keys.fsevtVarBool, val: CustomFieldBoolOperator } | { opt: filter.fsevtVarBools, key: filter_keys.fsevtVarBools, val: CustomFieldBoolsOperator } | { opt: filter.fsevtVarDate, key: filter_keys.fsevtVarDate, val: CustomFieldDateOperator } | { opt: filter.fsevtVarDates, key: filter_keys.fsevtVarDates, val: CustomFieldDatesOperator } | { opt: filter.fsevtVarFloat, key: filter_keys.fsevtVarFloat, val: CustomFieldFloatOperator } | { opt: filter.fsevtVarFloats, key: filter_keys.fsevtVarFloats, val: CustomFieldFloatsOperator } | { opt: filter.fsevtVarInt, key: filter_keys.fsevtVarInt, val: CustomFieldIntOperator } | { opt: filter.fsevtVarInts, key: filter_keys.fsevtVarInts, val: CustomFieldIntsOperator } | { opt: filter.fsevtVarString, key: filter_keys.fsevtVarString, val: CustomFieldStringOperator } | { opt: filter.fsevtVarStrings, key: filter_keys.fsevtVarStrings, val: CustomFieldStringsOperator } | { opt: filter.ipAddress, key: filter_keys.ipAddress, val: StringRangeOperator } | { opt: filter.mobileSourceFile, key: filter_keys.mobileSourceFile, val: StringOperator } | { opt: filter.name, key: filter_keys.name, val: StringOperator } | { opt: filter.nativePlatform, key: filter_keys.nativePlatform, val: NativePlatformOperator } | { opt: filter.none, key: filter_keys.none, val: NoneOperator } | { opt: filter.os, key: filter_keys.os, val: OSOperator } | { opt: filter.pageActiveDuration, key: filter_keys.pageActiveDuration, val: DurationOperator } | { opt: filter.pageDefId, key: filter_keys.pageDefId, val: PageRefOperator } | { opt: filter.pageDuration, key: filter_keys.pageDuration, val: DurationOperator } | { opt: filter.pageName, key: filter_keys.pageName, val: StringOperator } | { opt: filter.pageVarBool, key: filter_keys.pageVarBool, val: CustomFieldBoolOperator } | { opt: filter.pageVarBools, key: filter_keys.pageVarBools, val: CustomFieldBoolsOperator } | { opt: filter.pageVarDate, key: filter_keys.pageVarDate, val: CustomFieldDateOperator } | { opt: filter.pageVarDates, key: filter_keys.pageVarDates, val: CustomFieldDatesOperator } | { opt: filter.pageVarFloat, key: filter_keys.pageVarFloat, val: CustomFieldFloatOperator } | { opt: filter.pageVarFloats, key: filter_keys.pageVarFloats, val: CustomFieldFloatsOperator } | { opt: filter.pageVarInt, key: filter_keys.pageVarInt, val: CustomFieldIntOperator } | { opt: filter.pageVarInts, key: filter_keys.pageVarInts, val: CustomFieldIntsOperator } | { opt: filter.pageVarString, key: filter_keys.pageVarString, val: CustomFieldStringOperator } | { opt: filter.pageVarStrings, key: filter_keys.pageVarStrings, val: CustomFieldStringsOperator } | { opt: filter.pageviewActiveDuration, key: filter_keys.pageviewActiveDuration, val: DurationOperator } | { opt: filter.pageviewInactiveDuration, key: filter_keys.pageviewInactiveDuration, val: DurationOperator } | { opt: filter.pageviewTotalDuration, key: filter_keys.pageviewTotalDuration, val: DurationOperator } | { opt: filter.pinchGestureType, key: filter_keys.pinchGestureType, val: PinchGestureOperator } | { opt: filter.platform, key: filter_keys.platform, val: PlatformOperator } | { opt: filter.prevPageDefId, key: filter_keys.prevPageDefId, val: PageRefOperator } | { opt: filter.referrerUrl, key: filter_keys.referrerUrl, val: UrlOperator } | { opt: filter.region, key: filter_keys.region, val: StringOperator } | { opt: filter.requestMethod, key: filter_keys.requestMethod, val: StringOperator } | { opt: filter.scrollDepth, key: filter_keys.scrollDepth, val: NumericOperator } | { opt: filter.seenVisibility, key: filter_keys.seenVisibility, val: SeenVisibilityOperator } | { opt: filter.sessionEntryPage, key: filter_keys.sessionEntryPage, val: BoolOperator } | { opt: filter.sessionExitPage, key: filter_keys.sessionExitPage, val: BoolOperator } | { opt: filter.sessionStart, key: filter_keys.sessionStart, val: DateOperator } | { opt: filter.sessionType, key: filter_keys.sessionType, val: SessionTypeOperator } | { opt: filter.signedUp, key: filter_keys.signedUp, val: SignedUpOperator } | { opt: filter.start, key: filter_keys.start, val: DateOperator } | { opt: filter.statusCode, key: filter_keys.statusCode, val: NumericOperator } | { opt: filter.suspiciousActivityCategory, key: filter_keys.suspiciousActivityCategory, val: SuspiciousActivityCategoryOperator } | { opt: filter.suspiciousActivityType, key: filter_keys.suspiciousActivityType, val: SuspiciousActivityTypeOperator } | { opt: filter.text, key: filter_keys.text, val: TextOperator } | { opt: filter.timeDurationRendered, key: filter_keys.timeDurationRendered, val: DurationOperator } | { opt: filter.timeDurationVisible, key: filter_keys.timeDurationVisible, val: DurationOperator } | { opt: filter.timeSincePageLoad, key: filter_keys.timeSincePageLoad, val: DurationOperator } | { opt: filter.timeSinceSessionStart, key: filter_keys.timeSinceSessionStart, val: DurationOperator } | { opt: filter.url, key: filter_keys.url, val: UrlOperator } | { opt: filter.userAgent, key: filter_keys.userAgent, val: StringOperator } | { opt: filter.userId, key: filter_keys.userId, val: StringOperator } | { opt: filter.userVarBool, key: filter_keys.userVarBool, val: CustomFieldBoolOperator } | { opt: filter.userVarBools, key: filter_keys.userVarBools, val: CustomFieldBoolsOperator } | { opt: filter.userVarDate, key: filter_keys.userVarDate, val: CustomFieldDateOperator } | { opt: filter.userVarDates, key: filter_keys.userVarDates, val: CustomFieldDatesOperator } | { opt: filter.userVarFloat, key: filter_keys.userVarFloat, val: CustomFieldFloatOperator } | { opt: filter.userVarFloats, key: filter_keys.userVarFloats, val: CustomFieldFloatsOperator } | { opt: filter.userVarInt, key: filter_keys.userVarInt, val: CustomFieldIntOperator } | { opt: filter.userVarInts, key: filter_keys.userVarInts, val: CustomFieldIntsOperator } | { opt: filter.userVarString, key: filter_keys.userVarString, val: CustomFieldStringOperator } | { opt: filter.userVarStrings, key: filter_keys.userVarStrings, val: CustomFieldStringsOperator } | { opt: filter.viewportHeight, key: filter_keys.viewportHeight, val: NumericOperator } | { opt: filter.viewportWidth, key: filter_keys.viewportWidth, val: NumericOperator } | { opt: filter.webSourceFileUrl, key: filter_keys.webSourceFileUrl, val: UrlOperator } | null {
    if (m.city != null) { return { opt: filter.city, key: filter_keys.city, val: m.city } }
    if (m.region != null) { return { opt: filter.region, key: filter_keys.region, val: m.region } }
    if (m.country != null) { return { opt: filter.country, key: filter_keys.country, val: m.country } }
    if (m.email != null) { return { opt: filter.email, key: filter_keys.email, val: m.email } }
    if (m.name != null) { return { opt: filter.name, key: filter_keys.name, val: m.name } }
    if (m.signedUp != null) { return { opt: filter.signedUp, key: filter_keys.signedUp, val: m.signedUp } }
    if (m.userId != null) { return { opt: filter.userId, key: filter_keys.userId, val: m.userId } }
    if (m.userAgent != null) { return { opt: filter.userAgent, key: filter_keys.userAgent, val: m.userAgent } }
    if (m.appViewName != null) { return { opt: filter.appViewName, key: filter_keys.appViewName, val: m.appViewName } }
    if (m.appPackageName != null) { return { opt: filter.appPackageName, key: filter_keys.appPackageName, val: m.appPackageName } }
    if (m.appName != null) { return { opt: filter.appName, key: filter_keys.appName, val: m.appName } }
    if (m.deviceModel != null) { return { opt: filter.deviceModel, key: filter_keys.deviceModel, val: m.deviceModel } }
    if (m.deviceVendor != null) { return { opt: filter.deviceVendor, key: filter_keys.deviceVendor, val: m.deviceVendor } }
    if (m.browser != null) { return { opt: filter.browser, key: filter_keys.browser, val: m.browser } }
    if (m.device != null) { return { opt: filter.device, key: filter_keys.device, val: m.device } }
    if (m.platform != null) { return { opt: filter.platform, key: filter_keys.platform, val: m.platform } }
    if (m.nativePlatform != null) { return { opt: filter.nativePlatform, key: filter_keys.nativePlatform, val: m.nativePlatform } }
    if (m.os != null) { return { opt: filter.os, key: filter_keys.os, val: m.os } }
    if (m.pageDuration != null) { return { opt: filter.pageDuration, key: filter_keys.pageDuration, val: m.pageDuration } }
    if (m.pageActiveDuration != null) { return { opt: filter.pageActiveDuration, key: filter_keys.pageActiveDuration, val: m.pageActiveDuration } }
    if (m.ipAddress != null) { return { opt: filter.ipAddress, key: filter_keys.ipAddress, val: m.ipAddress } }
    if (m.appVersion != null) { return { opt: filter.appVersion, key: filter_keys.appVersion, val: m.appVersion } }
    if (m.appOsVersion != null) { return { opt: filter.appOsVersion, key: filter_keys.appOsVersion, val: m.appOsVersion } }
    if (m.appFsVersion != null) { return { opt: filter.appFsVersion, key: filter_keys.appFsVersion, val: m.appFsVersion } }
    if (m.timeSincePageLoad != null) { return { opt: filter.timeSincePageLoad, key: filter_keys.timeSincePageLoad, val: m.timeSincePageLoad } }
    if (m.timeSinceSessionStart != null) { return { opt: filter.timeSinceSessionStart, key: filter_keys.timeSinceSessionStart, val: m.timeSinceSessionStart } }
    if (m.consoleErrorsOnPage != null) { return { opt: filter.consoleErrorsOnPage, key: filter_keys.consoleErrorsOnPage, val: m.consoleErrorsOnPage } }
    if (m.consoleWarningsOnPage != null) { return { opt: filter.consoleWarningsOnPage, key: filter_keys.consoleWarningsOnPage, val: m.consoleWarningsOnPage } }
    if (m.displayWidth != null) { return { opt: filter.displayWidth, key: filter_keys.displayWidth, val: m.displayWidth } }
    if (m.displayHeight != null) { return { opt: filter.displayHeight, key: filter_keys.displayHeight, val: m.displayHeight } }
    if (m.viewportWidth != null) { return { opt: filter.viewportWidth, key: filter_keys.viewportWidth, val: m.viewportWidth } }
    if (m.viewportHeight != null) { return { opt: filter.viewportHeight, key: filter_keys.viewportHeight, val: m.viewportHeight } }
    if (m.referrerUrl != null) { return { opt: filter.referrerUrl, key: filter_keys.referrerUrl, val: m.referrerUrl } }
    if (m.url != null) { return { opt: filter.url, key: filter_keys.url, val: m.url } }
    if (m.text != null) { return { opt: filter.text, key: filter_keys.text, val: m.text } }
    if (m.css != null) { return { opt: filter.css, key: filter_keys.css, val: m.css } }
    if (m.element != null) { return { opt: filter.element, key: filter_keys.element, val: m.element } }
    if (m.elemVarString != null) { return { opt: filter.elemVarString, key: filter_keys.elemVarString, val: m.elemVarString } }
    if (m.elemVarFloat != null) { return { opt: filter.elemVarFloat, key: filter_keys.elemVarFloat, val: m.elemVarFloat } }
    if (m.elemVarInt != null) { return { opt: filter.elemVarInt, key: filter_keys.elemVarInt, val: m.elemVarInt } }
    if (m.elemVarBool != null) { return { opt: filter.elemVarBool, key: filter_keys.elemVarBool, val: m.elemVarBool } }
    if (m.elemVarDate != null) { return { opt: filter.elemVarDate, key: filter_keys.elemVarDate, val: m.elemVarDate } }
    if (m.elemVarStrings != null) { return { opt: filter.elemVarStrings, key: filter_keys.elemVarStrings, val: m.elemVarStrings } }
    if (m.elemVarFloats != null) { return { opt: filter.elemVarFloats, key: filter_keys.elemVarFloats, val: m.elemVarFloats } }
    if (m.elemVarInts != null) { return { opt: filter.elemVarInts, key: filter_keys.elemVarInts, val: m.elemVarInts } }
    if (m.elemVarDates != null) { return { opt: filter.elemVarDates, key: filter_keys.elemVarDates, val: m.elemVarDates } }
    if (m.elemVarBools != null) { return { opt: filter.elemVarBools, key: filter_keys.elemVarBools, val: m.elemVarBools } }
    if (m.userVarString != null) { return { opt: filter.userVarString, key: filter_keys.userVarString, val: m.userVarString } }
    if (m.userVarFloat != null) { return { opt: filter.userVarFloat, key: filter_keys.userVarFloat, val: m.userVarFloat } }
    if (m.userVarInt != null) { return { opt: filter.userVarInt, key: filter_keys.userVarInt, val: m.userVarInt } }
    if (m.userVarBool != null) { return { opt: filter.userVarBool, key: filter_keys.userVarBool, val: m.userVarBool } }
    if (m.userVarDate != null) { return { opt: filter.userVarDate, key: filter_keys.userVarDate, val: m.userVarDate } }
    if (m.customEventPropertyString != null) { return { opt: filter.customEventPropertyString, key: filter_keys.customEventPropertyString, val: m.customEventPropertyString } }
    if (m.customEventPropertyFloat != null) { return { opt: filter.customEventPropertyFloat, key: filter_keys.customEventPropertyFloat, val: m.customEventPropertyFloat } }
    if (m.customEventPropertyInt != null) { return { opt: filter.customEventPropertyInt, key: filter_keys.customEventPropertyInt, val: m.customEventPropertyInt } }
    if (m.customEventPropertyBool != null) { return { opt: filter.customEventPropertyBool, key: filter_keys.customEventPropertyBool, val: m.customEventPropertyBool } }
    if (m.customEventPropertyDate != null) { return { opt: filter.customEventPropertyDate, key: filter_keys.customEventPropertyDate, val: m.customEventPropertyDate } }
    if (m.apiEventName != null) { return { opt: filter.apiEventName, key: filter_keys.apiEventName, val: m.apiEventName } }
    if (m.customApiErrorProperty != null) { return { opt: filter.customApiErrorProperty, key: filter_keys.customApiErrorProperty, val: m.customApiErrorProperty } }
    if (m.userVarStrings != null) { return { opt: filter.userVarStrings, key: filter_keys.userVarStrings, val: m.userVarStrings } }
    if (m.userVarFloats != null) { return { opt: filter.userVarFloats, key: filter_keys.userVarFloats, val: m.userVarFloats } }
    if (m.userVarInts != null) { return { opt: filter.userVarInts, key: filter_keys.userVarInts, val: m.userVarInts } }
    if (m.customEventPropertyStrings != null) { return { opt: filter.customEventPropertyStrings, key: filter_keys.customEventPropertyStrings, val: m.customEventPropertyStrings } }
    if (m.customEventPropertyFloats != null) { return { opt: filter.customEventPropertyFloats, key: filter_keys.customEventPropertyFloats, val: m.customEventPropertyFloats } }
    if (m.customEventPropertyInts != null) { return { opt: filter.customEventPropertyInts, key: filter_keys.customEventPropertyInts, val: m.customEventPropertyInts } }
    if (m.userVarDates != null) { return { opt: filter.userVarDates, key: filter_keys.userVarDates, val: m.userVarDates } }
    if (m.userVarBools != null) { return { opt: filter.userVarBools, key: filter_keys.userVarBools, val: m.userVarBools } }
    if (m.customEventPropertyDates != null) { return { opt: filter.customEventPropertyDates, key: filter_keys.customEventPropertyDates, val: m.customEventPropertyDates } }
    if (m.customEventPropertyBools != null) { return { opt: filter.customEventPropertyBools, key: filter_keys.customEventPropertyBools, val: m.customEventPropertyBools } }
    if (m.fsUserId != null) { return { opt: filter.fsUserId, key: filter_keys.fsUserId, val: m.fsUserId } }
    if (m.fsPageClusterId != null) { return { opt: filter.fsPageClusterId, key: filter_keys.fsPageClusterId, val: m.fsPageClusterId } }
    if (m.fsSessionId != null) { return { opt: filter.fsSessionId, key: filter_keys.fsSessionId, val: m.fsSessionId } }
    if (m.pageName != null) { return { opt: filter.pageName, key: filter_keys.pageName, val: m.pageName } }
    if (m.pageVarString != null) { return { opt: filter.pageVarString, key: filter_keys.pageVarString, val: m.pageVarString } }
    if (m.pageVarFloat != null) { return { opt: filter.pageVarFloat, key: filter_keys.pageVarFloat, val: m.pageVarFloat } }
    if (m.pageVarInt != null) { return { opt: filter.pageVarInt, key: filter_keys.pageVarInt, val: m.pageVarInt } }
    if (m.pageVarBool != null) { return { opt: filter.pageVarBool, key: filter_keys.pageVarBool, val: m.pageVarBool } }
    if (m.pageVarDate != null) { return { opt: filter.pageVarDate, key: filter_keys.pageVarDate, val: m.pageVarDate } }
    if (m.pageVarStrings != null) { return { opt: filter.pageVarStrings, key: filter_keys.pageVarStrings, val: m.pageVarStrings } }
    if (m.pageVarFloats != null) { return { opt: filter.pageVarFloats, key: filter_keys.pageVarFloats, val: m.pageVarFloats } }
    if (m.pageVarInts != null) { return { opt: filter.pageVarInts, key: filter_keys.pageVarInts, val: m.pageVarInts } }
    if (m.pageVarDates != null) { return { opt: filter.pageVarDates, key: filter_keys.pageVarDates, val: m.pageVarDates } }
    if (m.pageVarBools != null) { return { opt: filter.pageVarBools, key: filter_keys.pageVarBools, val: m.pageVarBools } }
    if (m.requestMethod != null) { return { opt: filter.requestMethod, key: filter_keys.requestMethod, val: m.requestMethod } }
    if (m.statusCode != null) { return { opt: filter.statusCode, key: filter_keys.statusCode, val: m.statusCode } }
    if (m.pinchGestureType != null) { return { opt: filter.pinchGestureType, key: filter_keys.pinchGestureType, val: m.pinchGestureType } }
    if (m.webSourceFileUrl != null) { return { opt: filter.webSourceFileUrl, key: filter_keys.webSourceFileUrl, val: m.webSourceFileUrl } }
    if (m.mobileSourceFile != null) { return { opt: filter.mobileSourceFile, key: filter_keys.mobileSourceFile, val: m.mobileSourceFile } }
    if (m.scrollDepth != null) { return { opt: filter.scrollDepth, key: filter_keys.scrollDepth, val: m.scrollDepth } }
    if (m.seenVisibility != null) { return { opt: filter.seenVisibility, key: filter_keys.seenVisibility, val: m.seenVisibility } }
    if (m.timeDurationRendered != null) { return { opt: filter.timeDurationRendered, key: filter_keys.timeDurationRendered, val: m.timeDurationRendered } }
    if (m.timeDurationVisible != null) { return { opt: filter.timeDurationVisible, key: filter_keys.timeDurationVisible, val: m.timeDurationVisible } }
    if (m.pageDefId != null) { return { opt: filter.pageDefId, key: filter_keys.pageDefId, val: m.pageDefId } }
    if (m.prevPageDefId != null) { return { opt: filter.prevPageDefId, key: filter_keys.prevPageDefId, val: m.prevPageDefId } }
    if (m.sessionEntryPage != null) { return { opt: filter.sessionEntryPage, key: filter_keys.sessionEntryPage, val: m.sessionEntryPage } }
    if (m.sessionExitPage != null) { return { opt: filter.sessionExitPage, key: filter_keys.sessionExitPage, val: m.sessionExitPage } }
    if (m.errorClickType != null) { return { opt: filter.errorClickType, key: filter_keys.errorClickType, val: m.errorClickType } }
    if (m.browserVersion != null) { return { opt: filter.browserVersion, key: filter_keys.browserVersion, val: m.browserVersion } }
    if (m.ajaxRequestUrl != null) { return { opt: filter.ajaxRequestUrl, key: filter_keys.ajaxRequestUrl, val: m.ajaxRequestUrl } }
    if (m.start != null) { return { opt: filter.start, key: filter_keys.start, val: m.start } }
    if (m.sessionStart != null) { return { opt: filter.sessionStart, key: filter_keys.sessionStart, val: m.sessionStart } }
    if (m.datalossType != null) { return { opt: filter.datalossType, key: filter_keys.datalossType, val: m.datalossType } }
    if (m.datalossOrigin != null) { return { opt: filter.datalossOrigin, key: filter_keys.datalossOrigin, val: m.datalossOrigin } }
    if (m.pageviewTotalDuration != null) { return { opt: filter.pageviewTotalDuration, key: filter_keys.pageviewTotalDuration, val: m.pageviewTotalDuration } }
    if (m.pageviewActiveDuration != null) { return { opt: filter.pageviewActiveDuration, key: filter_keys.pageviewActiveDuration, val: m.pageviewActiveDuration } }
    if (m.pageviewInactiveDuration != null) { return { opt: filter.pageviewInactiveDuration, key: filter_keys.pageviewInactiveDuration, val: m.pageviewInactiveDuration } }
    if (m.definedEvent != null) { return { opt: filter.definedEvent, key: filter_keys.definedEvent, val: m.definedEvent } }
    if (m.sessionType != null) { return { opt: filter.sessionType, key: filter_keys.sessionType, val: m.sessionType } }
    if (m.dependentSet != null) { return { opt: filter.dependentSet, key: filter_keys.dependentSet, val: m.dependentSet } }
    if (m.none != null) { return { opt: filter.none, key: filter_keys.none, val: m.none } }
    if (m.fsevtVarFloat != null) { return { opt: filter.fsevtVarFloat, key: filter_keys.fsevtVarFloat, val: m.fsevtVarFloat } }
    if (m.fsevtVarInt != null) { return { opt: filter.fsevtVarInt, key: filter_keys.fsevtVarInt, val: m.fsevtVarInt } }
    if (m.fsevtVarString != null) { return { opt: filter.fsevtVarString, key: filter_keys.fsevtVarString, val: m.fsevtVarString } }
    if (m.fsevtVarBool != null) { return { opt: filter.fsevtVarBool, key: filter_keys.fsevtVarBool, val: m.fsevtVarBool } }
    if (m.fsevtVarDate != null) { return { opt: filter.fsevtVarDate, key: filter_keys.fsevtVarDate, val: m.fsevtVarDate } }
    if (m.fsevtVarFloats != null) { return { opt: filter.fsevtVarFloats, key: filter_keys.fsevtVarFloats, val: m.fsevtVarFloats } }
    if (m.fsevtVarInts != null) { return { opt: filter.fsevtVarInts, key: filter_keys.fsevtVarInts, val: m.fsevtVarInts } }
    if (m.fsevtVarStrings != null) { return { opt: filter.fsevtVarStrings, key: filter_keys.fsevtVarStrings, val: m.fsevtVarStrings } }
    if (m.fsevtVarDates != null) { return { opt: filter.fsevtVarDates, key: filter_keys.fsevtVarDates, val: m.fsevtVarDates } }
    if (m.fsevtVarBools != null) { return { opt: filter.fsevtVarBools, key: filter_keys.fsevtVarBools, val: m.fsevtVarBools } }
    if (m.suspiciousActivityType != null) { return { opt: filter.suspiciousActivityType, key: filter_keys.suspiciousActivityType, val: m.suspiciousActivityType } }
    if (m.suspiciousActivityCategory != null) { return { opt: filter.suspiciousActivityCategory, key: filter_keys.suspiciousActivityCategory, val: m.suspiciousActivityCategory } }
    return null;
  }
}

export interface EventSetOperator {
  union?: EventSetValue | null;
  intersection?: EventSetValue | null;
}

export namespace EventSetOperator {
  export enum operator {
    union = 1,
    intersection = 2
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    union = 'union',
    intersection = 'intersection'
  }

  export function operator_oneof(m: EventSetOperator): { opt: operator.intersection, key: operator_keys.intersection, val: EventSetValue } | { opt: operator.union, key: operator_keys.union, val: EventSetValue } | null {
    if (m.union != null) { return { opt: operator.union, key: operator_keys.union, val: m.union } }
    if (m.intersection != null) { return { opt: operator.intersection, key: operator_keys.intersection, val: m.intersection } }
    return null;
  }
}

export interface EventSetValue {
  events: Event[];
}

export interface DependentEventSetOperator {
  union?: DependentEventSetValue | null;
  intersection?: DependentEventSetValue | null;
}

export namespace DependentEventSetOperator {
  export enum operator {
    union = 1,
    intersection = 2
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum operator_keys {
    union = 'union',
    intersection = 'intersection'
  }

  export function operator_oneof(m: DependentEventSetOperator): { opt: operator.intersection, key: operator_keys.intersection, val: DependentEventSetValue } | { opt: operator.union, key: operator_keys.union, val: DependentEventSetValue } | null {
    if (m.union != null) { return { opt: operator.union, key: operator_keys.union, val: m.union } }
    if (m.intersection != null) { return { opt: operator.intersection, key: operator_keys.intersection, val: m.intersection } }
    return null;
  }
}

export interface DependentEventSetValue {
  deps: DependentEventFilter[];
}
